import { Table, Grid } from "semantic-ui-react";
import "./Tables.css";

const Tables = ({ headers, data }) => {
  console.log(headers, data);
  return (
      <div className="table_container">
        <Table celled>
          <Table.Header>
            <Table.Row>
              {headers.map((header) => {
                //console.log(header);
                return (
                    <Table.HeaderCell>
                      <Grid>
                        <Grid.Row columns={2}>
                          <Grid.Column width={15}>
                              {header}
                          </Grid.Column>
                          <Grid.Column width={1}>
                          {/* <Icon name="filter" size="small" /> */}
                          </Grid.Column>
                      </Grid.Row>
                      </Grid>
                    </Table.HeaderCell>
                );
              })}
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {data.map((element) => {
              return (
                <Table.Row>
                  {headers.map((header) => {
                    //console.log(element[header]);
                    return <Table.Cell>{element[header]}</Table.Cell>;
                  })}
                </Table.Row>
              );
            })}
          </Table.Body>
        </Table>
      </div>
  );
};
export default Tables;
